const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const RESIZABLE = ['/api/social-media/', '/api/static/'];

// Covers/creatives are stored at 1080x1440; ask the backend for a right-sized cached WebP.
// Anything else (absolute URLs, blobs, cache-busted paths) is returned untouched.
export const thumb = (path, w = 480) => {
  if (!path) return '';
  if (!path.startsWith('/')) return path;
  const clean = path.split('?')[0];
  if (!RESIZABLE.some((p) => clean.startsWith(p))) return `${BACKEND_URL}${path}`;
  return `${BACKEND_URL}/api/img?src=${encodeURIComponent(clean)}&w=${w}`;
};

export const thumbSet = (path, widths = [360, 480, 720]) => {
  if (!path || !path.startsWith('/')) return undefined;
  const clean = path.split('?')[0];
  if (!RESIZABLE.some((p) => clean.startsWith(p))) return undefined;
  return widths.map((w) => `${thumb(clean, w)} ${w}w`).join(', ');
};
